import { render, staticRenderFns } from "./SettingsHome.vue?vue&type=template&id=39ffe49f&scoped=true&"
import script from "./SettingsHome.vue?vue&type=script&lang=js&"
export * from "./SettingsHome.vue?vue&type=script&lang=js&"
import style0 from "./SettingsHome.vue?vue&type=style&index=0&id=39ffe49f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ffe49f",
  null
  
)

export default component.exports